module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_mobile_03.74fb645a.png";